import { Grid } from "@mui/material";
import { get } from "lodash";
import CodingSystems from "../../constants/CodingSystems";
import { FamilyHistoryConditionFormatted } from "../../pages/health/encounters/types/familyHistoryTypes";
import { CodeableConcept } from "../../types/codeableConcept";
import { createCodeableConcept } from "../../utils/DataUtils";
import TypeAheadInput from "./TypeAheadInput/TypeAheadInput";

type Props = {
  disabled?: boolean;
  intItem?: FamilyHistoryConditionFormatted;
  onConditionUpdate?: (codeableConcept: CodeableConcept) => void;
};

const ConditionInputNew = ({ disabled, intItem, onConditionUpdate }: Props) => {
  return (
    <Grid item xs={12} sx={{ mb: 2 }}>
      <TypeAheadInput
        required
        freeOptions
        optionType="snomed"
        subset={["disorder", "finding", "event", "situation"]}
        value={get(intItem, "condition", {})}
        variant="outlined"
        disabled={disabled}
        onChange={(val) => {
          if (val) {
            const codeableConcept = createCodeableConcept(
              CodingSystems.CONDITION_CODE,
              val.snomedCID,
              val.snomedFSN,
            );
            onConditionUpdate(codeableConcept);
          } else {
            onConditionUpdate(undefined);
          }
        }}
        getValueLabel={(v) => get(v, "text")}
        fieldLabel="Add Medical Condition"
        getOptionLabel={(o) => o.snomedFSN}
      />
    </Grid>
  );
};

export default ConditionInputNew;
